
namespace RioERP.Enquiry {
    export class EnquiryProductsColumns {
        static columnsKey = 'Enquiry.EnquiryProducts';
    }
}